import { getUserFiles } from '../../../../../api/preview/edit/getHistoryPreview'
import React, { useEffect, useState } from 'react'

import styled from 'styled-components'
import BaseListFiles, { FileHistory } from './BaseListFiles'

export default function ListUserFiles({
    onChange,
    select,
    collection = ''
}: {
    onChange: (file: FileHistory) => void
    select: FileHistory
    collection?: string
}) {
    return (
        <BaseListFiles
            collection={collection}
            label="Select a history file"
            onChange={onChange}
            select={select}
            getFilesHitory={() => getUserFiles()}
            isClearable={true}
        />
    )
}
